import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import BrButton from '@govbr/react-components/lib/BrButton';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../../Perfil/perfilSlice';
import { authLogout, selectGateway } from '../../../auth/authSlice';
import auth from '../../../auth/Auth';
import carteiraDocumentosImg from '../../../assets/img/carteira-documentos.svg';
import styles from './AvisoCarteiraDocumentos.module.css';

const AvisoCarteiraDocumentos: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [naoExibirMensagem, setNaoExibirMensagem] = useState(false);
  
  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const gatewayLogado = useAppSelector(selectGateway).logado;

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const isLogado = () => {
    return auth.isAuthenticated() && auth.getUser() && gatewayLogado;
  };

  const voltarParaPainel = () => {
    history.push('/home');
  };

  const irParaCarteiraDocumentos = () => {
    history.replace('/carteira-documentos');
  };

  const handleCheckboxChange = (checked: boolean) => {
    setNaoExibirMensagem(checked);
    if (checked) {
      localStorage.setItem('cadunico/aviso-carteira-documentos-nao-exibir', 'true');
    } else {
      localStorage.removeItem('cadunico/aviso-carteira-documentos-nao-exibir');
    }
  };

  return (
      <div className={styles.container}>
        <div className={styles.headerSection}>
          <div className={styles.imageContainer}>
            <img 
              src={carteiraDocumentosImg} 
              alt="Carteira de Documentos" 
              className={styles.carteiraImage}
            />
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.textContent}>
            <p className={styles.mainText}>
              Você, Responsável Familiar (RF), pode guardar <strong>documentos biométricos digitais</strong> na <strong>carteira de documentos</strong> dos integrantes da sua família.
            </p>
            
            <p className={styles.acceptedDocsTitle}>São aceitos:</p>
            <ul className={styles.docsList}>
              <li>CIN (Carteira de Identidade Nacional);</li>
              <li>CNH (Carteira Nacional de Habilitação);</li>
              <li>e-Título (Título de Eleitor Digital).</li>
            </ul>
            
            <p className={styles.benefitText}>
              Assim, não será mais necessária a apresentação destes documentos no 
              atendimento presencial.
            </p>
          </div>
          
          <div className={styles.buttonContainer}>
            <BrButton 
              className={styles.primaryButton}
              onClick={irParaCarteiraDocumentos}
            >
              Ir para a carteira de documentos
            </BrButton>
          </div>
          
          <div className={styles.checkboxContainer}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                id="nao-exibir-mensagem"
                checked={naoExibirMensagem}
                onChange={(e) => handleCheckboxChange(e.target.checked)}
                className={styles.checkboxInput}
              />
              <span className={styles.checkboxText}>Não exibir mais esta mensagem</span>
            </label>
          </div>
        </div>
      </div>
  );
};

export default AvisoCarteiraDocumentos;